export const VERIFY_EMAIL = 'verify_email';
export const CREATE_USER_FAIL = 'create_user_fail';

export const FETCH_EVENTS_LOADING = 'fetch_events_loading';
export const FETCH_EVENTS_SUCCESS = 'fetch_events_success';
export const FETCH_LOCATIONS_LOADING = 'fetch_locations_loading';
export const FETCH_LOCATIONS_SUCCESS = 'fetch_locations_success';

export const UPDATE_MARKER = 'update_marker';
export const MOVE_MARKERS = 'move_marker';
export const SET_CENTER = 'set_center';
export const BULK_EDIT_MARKER = 'bulk_edit_marker';
export const TOGGLE_OVERLAY = 'toggle_overlay';
export const SET_ACTIVE_MARKER = 'set_active_marker';
export const EDIT_MARKER = 'edit_marker';
export const SET_INFO = 'set_info';
export const CLOSE_INFO = 'close_info';
export const SET_EVENT_ID = 'set_event_id';
export const SET_EVENT_NAME = 'set_event_name';
export const SET_TEMPLATE = 'set_template';
export const SET_INFO_AUTH = 'set_info_auth';
export const SET_START_DATE = 'set_start_date';
export const SET_IS_ADMIN = 'set_is_admin';
export const GET_PLACEHOLDERS = 'get_placeholders';
export const SET_PLACEHOLDERS = 'set_placeholder';
export const SET_BACKGROUND_IMAGE = 'set_background_image';
export const RESET_MARKER_KEY = 'reset_marker_key';
export const OMIT_QUESTION = 'omit_question';
export const SET_IMAGE_CAROUSEL = 'set_image_carousel';
export const FETCH_IMAGES_FAIL = 'fetch_images_fail';
export const FETCH_IMAGES_LOADING = 'fetch_images_loading';
export const FETCH_IMAGES_SUCCESS = 'fetch_images_success';
export const TRANSLATE_LOADING = 'translate_loading';
export const TRANSLATE_FAIL = 'translate_fail';
export const BULK_SET_PLACEHOLDER = 'bulk_set_placeholder';
export const UPLOAD_ICON_LOADING = 'upload_icon_loading';
export const UPLOAD_ICON_SUCCESS = 'upload_icon_success';
export const UPLOAD_ICON_FAIL = 'upload_icon_fail';
export const SET_ICON = 'set_icon';
export const DELETE_ICON_LOADING = 'delete_icon_loading';
export const DELETE_ICON_SUCCESS = 'delete_icon_success';
export const DELETE_ICON_FAIL = 'delete_icon_fail';
export const FETCH_ICON_FAIL = 'fetch_icon_fail';
